import * as React from 'react'
import { withStyles, WithStyles } from '@zn-material-ui'
import agreementStyles from './styles/AgreementStyle'
import Store from 'store'
import { transform } from '@utils/intl_lang'
import Service from '../Agreements/Service'
const title = Store.get('isCustomLogin')
  ? transform('Service_Agreement') // 服务协议
  : transform('Ping_An_Software_Agreement') // e祺学软件许可及服务协议

interface IProps extends WithStyles<typeof agreementStyles> {
  handleAgree: () => void
}

const Agreement: React.SFC<IProps> = ({ classes, handleAgree }) => (
  <>
    <div className={classes.title}>{title}</div>
    <section className={classes.content}>
      <Service hideTitle />
    </section>
  </>
)

export default withStyles(agreementStyles)(Agreement)
